<template>
  <standard-layout header="Gutschein erstellen und versenden">
    <template v-slot:main>
      <div class="container mt-4">
        <form @submit.prevent="submitVoucher">
          <div class="form-group">
            <label for="email">E-Mail-Adresse des Empfängers</label>
            <input
                type="email"
                id="email"
                v-model="form.email"
                class="form-control"
                required
            />
          </div>

          <div class="form-group">
            <label for="discount">Rabatt (%)</label>
            <input
                type="number"
                id="discount"
                v-model.number="form.discount"
                class="form-control"
                min="1"
                max="100"
                required
            />
          </div>

          <div class="form-group">
            <label for="validUntil">Gültig bis</label>
            <input
                type="date"
                id="validUntil"
                v-model="form.validUntil"
                class="form-control"
                required
            />
          </div>

          <button type="submit" class="btn btn-primary" :disabled="loading">
            Gutschein senden
          </button>

          <div v-if="successMessage" class="alert alert-success mt-3">
            {{ successMessage }}
          </div>
          <div v-if="errorMessage" class="alert alert-danger mt-3">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";
export default {
  name: 'VoucherSender',
  data() {
    return {
      form: {
        email: '',
        discount: null,
        validUntil: ''
      },
      loading: false,
      successMessage: '',
      errorMessage: ''
    };
  },
  methods: {
    async submitVoucher() {
      this.loading = true;
      this.successMessage = '';
      this.errorMessage = '';
      try {
        await this.$api.post('vouchers', {
          email: this.form.email,
          discount: this.form.discount,
          validUntil: this.form.validUntil
        });
        this.successMessage = 'Gutschein wurde erfolgreich versendet!';
        this.form.email = '';
        this.form.discount = null;
        this.form.validUntil = '';
      } catch (error) {
        this.errorMessage = 'Fehler beim Versenden des Gutscheins.';
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  components: {
    StandardLayout
  }
};
</script>
